import ARTICLE_DATES from "../data/articleDates";

// Fenêtre (en jours) pendant laquelle un article est badgé « Nouveau » / « Mis à jour ».
export const RECENT_DAYS = 30;

const MS_PER_DAY = 86400000;

/** Dates { createdAt, updatedAt } d'un slug (updatedAt retombe sur createdAt si absent). */
export const datesForSlug = (slug) => {
  const d = ARTICLE_DATES[slug] || {};
  return {
    createdAt: d.createdAt || null,
    updatedAt: d.updatedAt || d.createdAt || null,
  };
};

/** Nombre de jours écoulés depuis une date ISO (YYYY-MM-DD). Infinity si absente/invalide. */
export const daysSince = (iso, now = Date.now()) => {
  if (!iso) return Infinity;
  const ts = Date.parse(`${iso}T00:00:00`);
  return Number.isNaN(ts) ? Infinity : Math.floor((now - ts) / MS_PER_DAY);
};

/**
 * Récence d'un article :
 *   - 'new'     s'il a été créé dans les RECENT_DAYS derniers jours
 *   - 'updated' s'il a été mis à jour récemment (et que ce n'est pas une simple création)
 *   - null      sinon
 */
export const recencyOf = (article, now = Date.now()) => {
  if (!article) return null;
  const created = article.createdAt;
  const updated = article.updatedAt || created;
  if (daysSince(created, now) <= RECENT_DAYS) return "new";
  if (updated && updated !== created && daysSince(updated, now) <= RECENT_DAYS) {
    return "updated";
  }
  return null;
};

/** Formate une date ISO en date locale courte (JJ/MM/AAAA) selon la langue. */
export const formatArticleDate = (iso, lang = "fr") => {
  if (!iso) return "";
  const ts = Date.parse(`${iso}T00:00:00`);
  if (Number.isNaN(ts)) return "";
  const locale = ({ fr: "fr-FR", en: "en-GB", de: "de-DE", nl: "nl-NL", es: "es-ES" })[String(lang).toLowerCase().split(/[-_]/)[0]] || "fr-FR";
  try {
    return new Intl.DateTimeFormat(locale, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(new Date(ts));
  } catch (e) {
    return iso;
  }
};

/** Trie (sur une copie) une liste d'articles par date décroissante sur le champ donné. */
export const sortArticlesByDate = (list, field) =>
  [...list].sort((a, b) => {
    const av = a[field] || a.createdAt || "";
    const bv = b[field] || b.createdAt || "";
    if (bv < av) return -1;
    if (bv > av) return 1;
    return 0;
  });
